import { render } from "./CategoryNotif.vue?vue&type=template&id=c9139c12&scoped=true"
import script from "./CategoryNotif.vue?vue&type=script&lang=js"
export * from "./CategoryNotif.vue?vue&type=script&lang=js"

import "./CategoryNotif.vue?vue&type=style&index=0&id=c9139c12&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9139c12"]])

export default __exports__